/* eslint no-nested-ternary: 1 */
import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { deleteCarrierLogo } from '../../../actions/logos';

class LogoLibrary extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      selectedLogo: {},
    };
  }

  toggle = () => {
    this.setState((prevState) => ({ deleteModal: !prevState.deleteModal }));
  };

  render() {
    const { logosLoading, logosList, deletingLogo } = this.props;
    const { deleteModal, selectedLogo } = this.state;

    return (
      <>
        <Row className="mb-5 fade-in">
          <Col className="d-flex ms-5 flex-wrap">
            {
              logosLoading
                ? (
                  <div className="m-auto">
                    <Spinner color="dark" type="grow" style={{ width: '5rem', height: '5rem' }} />
                    <Spinner color="dark" type="grow" style={{ width: '5rem', height: '5rem' }} />
                    <Spinner color="dark" type="grow" style={{ width: '5rem', height: '5rem' }} />
                  </div>
                ) : (
                  logosList.length
                    ? (
                      logosList.map((logo) => (
                        <div className="d-flex flex-column mb-3">
                          <div className="font-weight-bold m-auto">{logo.logo_name}</div>
                          <Card
                            className="d-flex flex-row justify-content-between shadow me-3 mt-2"
                            style={{
                              borderRadius: '.5rem',
                              height: '100px',
                              width: '350px',
                            }}
                          >
                            <img
                              src={logo.url}
                              alt={logo.logo_name}
                              style={{ objectFit: 'contain', width: '200px', margin: 'auto' }}
                            />
                            <Button
                              outline
                              color="darkgray"
                              onClick={
                                () => this.setState({ deleteModal: true, selectedLogo: logo })
                              }
                            >
                              <FontAwesomeIcon icon={faTrashAlt} fixedWidth />
                            </Button>
                          </Card>
                        </div>
                      ))
                    ) : (
                      <div>There were no logos found.</div>
                    )
                )
            }
          </Col>
        </Row>
        <Modal isOpen={deleteModal} toggle={this.toggle} className="fade-in" zIndex="100000">
          <ModalHeader toggle={this.toggle}>Warning!</ModalHeader>
          <ModalBody>
            Are you sure you want to delete the logo for&nbsp;
            <span className="font-weight-bold">{selectedLogo.logo_name}</span>
            ?
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={() => {
                deleteCarrierLogo(selectedLogo.id).then(() => this.toggle());
              }}
              disabled={deletingLogo}
            >
              {deletingLogo ? <Spinner size="sm" className="me-1" /> : null}
              Delete
            </Button>
            <Button
              color="secondary"
              outline
              onClick={this.toggle}
              disabled={deletingLogo}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  logosList: store.logos.logosList,
  logosLoading: store.logos.logosLoading,
  logosLoadingError: store.logos.logosLoadingError,
  deletingLogo: store.logos.deletingLogo,
});

export default connect(mapStateToProps)(LogoLibrary);
